import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'carm-main-body-container',
  templateUrl: './main-body-container.component.html',
  styleUrls: ['./main-body-container.component.scss'],
})
export class MainBodyContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
